import React from 'react'
import ReactDOM from 'react-dom'
import ShortcodeApp from './ShortcodeProgram/ShortcodeApp';
import "./entryHelpers"
import { Provider } from 'react-redux';
import { store } from './store';


const iOS = (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) && !window.MSStream
const Firefox = /Firefox/.test(navigator.userAgent) && !window.MSStream
const Android = /Android/.test(navigator.userAgent) && !window.MSStream
const Mobile = /Mobile/.test(navigator.userAgent) && !window.MSStream
const elemApp = document.querySelector('#pm-app')

if((Android && Mobile && Firefox) || iOS)  {
    document.querySelector('html').classList.add('is-ios')
}

if(elemApp) {
    ReactDOM.render(<Provider store={store}><ShortcodeApp /></Provider>, elemApp)
}